/**
 * Wire-level enumerations.
 *
 * The backend never serialises Java enum names: the values below are the
 * literal numbers/strings that arrive in the two `getDiagramDataForPeriod`
 * payloads. Keep the numeric values — they are the contract.
 */
/** `type` of an activity segment. Meaning is identical for 0..3 in both endpoints. */
export const ActivityType = {
    REST: 0,
    AVAILABILITY: 1,
    WORK: 2,
    DRIVING: 3,
    /**
     * Vehicle endpoint only: `drivingStatus === "UNKNOWN"` (unattributed).
     * The vehicle feed may also emit 5..7 for other "no card" conditions.
     */
    UNATTRIBUTED: 4,
};
/**
 * Segment types that mean "no card / not attributable" on the vehicle feed.
 * 4 is the documented one; 5..7 are emitted by some deployments, so they are
 * treated the same way by default.
 */
export const NO_CARD_TYPES = [4, 5, 6, 7];
/** `drivingStatus` — driver endpoint only. */
export const DrivingStatus = {
    UNSET: 0,
    SINGLE: 1,
    CREW: 2,
    MANUAL: 3,
    UNKNOWN: 4,
};
/** `cardSlot` — driver endpoint only (1-based). */
export const CardSlot = {
    DRIVER: 1,
    CO_DRIVER: 2,
};
/** Raw activity names, exactly as serialised (`typeName` / `typeString`). */
export const ActivityName = {
    REST: "BREAK/REST",
    AVAILABILITY: "AVAILABILITY",
    WORK: "WORK",
    DRIVING: "DRIVING",
};
/** `entryType` — capitalised exactly like this on the wire. */
export const EntryType = {
    AUTOMATIC: "Automatic",
    MANUAL: "Manual",
    CARD_WITHDRAWAL: "Card withdrawal",
};
/** Backend `Enums.TypeOfAccount` — not serialised; kept for reference. */
export const TypeOfAccount = {
    STANDARD: 0,
    TEST: 1,
    JUST_ME: 2,
};
/** Maps a wire `type` to the chart's colour bucket. Types 4..7 are "no card". */
export function activityKind(type) {
    switch (type) {
        case ActivityType.REST:
            return "rest";
        case ActivityType.AVAILABILITY:
            return "availability";
        case ActivityType.WORK:
            return "work";
        case ActivityType.DRIVING:
            return "driving";
        default:
            return "noCard";
    }
}
